export default __webpack_public_path__ + "static/media/daniel.3742498d.png";